import { render, staticRenderFns } from "./hospitalization.vue?vue&type=template&id=681cef84&scoped=true&"
import script from "./hospitalization.vue?vue&type=script&lang=js&"
export * from "./hospitalization.vue?vue&type=script&lang=js&"
import style0 from "./hospitalization.vue?vue&type=style&index=0&id=681cef84&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "681cef84",
  null
  
)

export default component.exports